module.exports = __webpack_public_path__ + "img/FLSH9.65b49383.svg";